/* eslint-disable @typescript-eslint/no-unused-vars */
/** @jsxImportSource @emotion/react */

import { Maybe } from "graphql/jsutils/Maybe";
import { FC, useMemo } from "react";
import ProviderLogo from "../../../../components/ProviderLogos/ProviderLogo";
import Typography from "../../../../components/Typography";
import {
  BasicCoverageTypes,
  Result,
  ResultStatus,
} from "../../../../graphql/__GENERATED__/types";
BasicCoverageTypes;
import {
  CSSRulesResolver,
  useCSSRulesWithTheme,
} from "../../../../hooks/useCSSRulesWithTheme";
import { useUIStore } from "../../../../hooks/useUIStore";
import { theme, getThemeColorFromAlias, ColorNames } from "../../../../theme";
import { returnCoverageType } from "../../DocumentDetails/components/QuotationCard";

const getCSSRules: CSSRulesResolver<{
  active: boolean;
  color: string;
  disabled?: boolean;
}> = ({ active, color, disabled }) => ({
  button: {
    cursor: disabled ? "not-allowed" : "pointer",
    backgroundColor: theme.colors.White[100],
    padding: 12,
    margin: 12,
    boxSizing: "border-box",
    width: "100%",
    border: active ? "2px solid" : "1px solid",
    borderColor: active ? color : theme.colors.Grey[100],
    borderRadius: 10,
    boxShadow: active ? "0px 4px 4px rgba(0, 0, 0, 0.07)" : "none",
  },
});

interface InsuranceCompanyButtonProps {
  result: Result;
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const InsuranceCompanyButton: FC<InsuranceCompanyButtonProps> = ({
  result,
  active,
  disabled,
  onClick,
}) => {
  const { documentColor } = useUIStore();
  const color = getThemeColorFromAlias(documentColor, theme.colors)!;
  const styles = useCSSRulesWithTheme(getCSSRules, {
    active,
    color,
    disabled,
  });

  const handleClick = () => {
    if (disabled) return;
    onClick();
  };

  return (
    <div css={styles.button} onClick={handleClick}>
      <ProviderLogo
        provider={result.provider!}
        color={active ? documentColor : ColorNames.GREY}
      />
      <Typography
        variant="textMedium"
        align="center"
        component="p"
        color={active ? documentColor : ColorNames.GREY}
        uppercase
      >
        {returnCoverageType(result.basicCoverageType)}
      </Typography>
    </div>
  );
};

export default InsuranceCompanyButton;
